var familyTokenRegex = /\[familyname\]/mgi;
export var replaceFamilyTokens = function (html, product) {
    if (!product) {
        return html;
    }
    return product ? html.replace(familyTokenRegex, product.familyName) : html;
};
